var _path, _g, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlexibleOperation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.18808 4.04891L5.70537 7.55488L1.62795 5.04528C1.09366 4.71637 1.20196 3.90493 1.80385 3.73024L11.4305 0.92907C11.978 0.770638 12.4841 1.28388 12.3202 1.83388L9.46389 11.4506C9.285 12.0524 8.48268 12.1566 8.1584 11.6193L5.70537 7.55488",
    fill: "url(#paint0_linear_9308_7466)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_9308_7466)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.68903 4.83791L6.61207 6.92875L4.18045 5.43211C3.86182 5.23596 3.9264 4.75205 4.28535 4.64787L10.0263 2.97736C10.3528 2.88287 10.6547 3.18895 10.5569 3.51695L8.85352 9.25202C8.74684 9.61091 8.26836 9.67306 8.07497 9.35261L6.61207 6.92875",
    fill: "#E46800"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: -3.67207,
    y: -1.0168,
    width: 22.5885,
    height: 22.5888
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2.15px)",
      clipPath: "url(#bgblur_0_9308_7466_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 4.29317
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1_9308_7466",
    maskUnits: "userSpaceOnUse",
    x: -0.199951,
    y: 2.45557,
    width: 15,
    height: 15,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: -0.199951,
    y: 2.45557,
    width: 15,
    height: 15
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5446 7.33743L6.25137 11.6593L1.22502 8.56569C0.566398 8.16023 0.699893 7.15995 1.44186 6.9446L13.3089 3.49152C13.9838 3.29622 14.6077 3.92891 14.4056 4.6069L10.8846 16.4617C10.6641 17.2036 9.67504 17.332 9.2753 16.6696L6.25137 11.6593"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5446 7.33743L6.25137 11.6593L1.22502 8.56569C0.566398 8.16023 0.699893 7.15995 1.44186 6.9446L13.3089 3.49152C13.9838 3.29622 14.6077 3.92891 14.4056 4.6069L10.8846 16.4617C10.6641 17.2036 9.67504 17.332 9.2753 16.6696L6.25137 11.6593",
    fill: "#FFCBB9",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6715 7.4635C10.7411 7.39341 10.7408 7.28015 10.6707 7.21052C10.6006 7.1409 10.4873 7.14127 10.4177 7.21136L10.6715 7.4635ZM6.25137 11.6593L6.15761 11.8117C6.22835 11.8552 6.31975 11.8443 6.37828 11.7854L6.25137 11.6593ZM1.22502 8.56569L1.13125 8.71802L1.13126 8.71803L1.22502 8.56569ZM1.44186 6.9446L1.49172 7.11639L1.49184 7.11635L1.44186 6.9446ZM13.3089 3.49152L13.2592 3.31969L13.2589 3.31976L13.3089 3.49152ZM14.4056 4.6069L14.2342 4.5558L14.2342 4.55597L14.4056 4.6069ZM10.8846 16.4617L11.0561 16.5127L11.0561 16.5126L10.8846 16.4617ZM9.2753 16.6696L9.42845 16.5772L9.42844 16.5772L9.2753 16.6696ZM6.40452 11.5669C6.35347 11.4823 6.24352 11.4551 6.15894 11.5062C6.07436 11.5572 6.04717 11.6672 6.09822 11.7518L6.40452 11.5669ZM10.5446 7.33743L10.4177 7.21136L6.12446 11.5333L6.25137 11.6593L6.37828 11.7854L10.6715 7.4635L10.5446 7.33743ZM6.25137 11.6593L6.34514 11.507L1.31879 8.41335L1.22502 8.56569L1.13126 8.71803L6.15761 11.8117L6.25137 11.6593ZM1.22502 8.56569L1.3188 8.41335C0.791416 8.08869 0.89981 7.28819 1.49172 7.11639L1.44186 6.9446L1.392 6.7728C0.499976 7.03171 0.34138 8.23176 1.13125 8.71802L1.22502 8.56569ZM1.44186 6.9446L1.49184 7.11635L13.3589 3.66328L13.3089 3.49152L13.2589 3.31976L1.39188 6.77284L1.44186 6.9446ZM13.3089 3.49152L13.3586 3.66335C13.8957 3.50793 14.3964 4.01158 14.2342 4.5558L14.4056 4.6069L14.5771 4.658C14.819 3.84624 14.0719 3.0845 13.2592 3.31969L13.3089 3.49152ZM14.4056 4.6069L14.2342 4.55597L10.7131 16.4108L10.8846 16.4617L11.0561 16.5126L14.5771 4.65783L14.4056 4.6069ZM10.8846 16.4617L10.7131 16.4107C10.5366 17.0046 9.74738 17.1057 9.42845 16.5772L9.2753 16.6696L9.12214 16.7621C9.6027 17.5584 10.7916 17.4025 11.0561 16.5127L10.8846 16.4617ZM9.2753 16.6696L9.42844 16.5772L6.40452 11.5669L6.25137 11.6593L6.09822 11.7518L9.12214 16.7621L9.2753 16.6696Z",
    fill: "url(#paint1_linear_9308_7466)",
    mask: "url(#path-3-outside-1_9308_7466)"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 4.54236,
    y: 4.46106,
    width: 8.90357,
    height: 8.90357
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.34px)",
      clipPath: "url(#bgblur_1_9308_7466_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_9308_7466)",
    "data-figma-bg-blur-radius": 2.68323
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.05884,
    y: 10.2788,
    width: 4.66882,
    height: 0.804969,
    rx: 0.402485,
    transform: "rotate(-45 7.05884 10.2788)",
    fill: "url(#paint2_linear_9308_7466)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.10943,
    y: 10.2788,
    width: 4.59727,
    height: 0.733416,
    rx: 0.366708,
    transform: "rotate(-45 7.10943 10.2788)",
    stroke: "url(#paint3_linear_9308_7466)",
    strokeWidth: 0.0715528
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_9308_7466",
    x: 1.47051,
    y: 0.455613,
    width: 11.6095,
    height: 11.6095,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.25217,
    result: "effect1_foregroundBlur_9308_7466"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_9308_7466_clip_path",
    transform: "translate(3.67207 1.0168)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5446 7.33743L6.25137 11.6593L1.22502 8.56569C0.566398 8.16023 0.699893 7.15995 1.44186 6.9446L13.3089 3.49152C13.9838 3.29622 14.6077 3.92891 14.4056 4.6069L10.8846 16.4617C10.6641 17.2036 9.67504 17.332 9.2753 16.6696L6.25137 11.6593"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_9308_7466",
    x: 4.54236,
    y: 4.46106,
    width: 8.90357,
    height: 8.90357,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.89441,
    dy: 0.89441
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.89441
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.580392 0 0 0 0 0.247059 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9308_7466"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9308_7466",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_9308_7466_clip_path",
    transform: "translate(-4.54236 -4.46106)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.05884,
    y: 10.2788,
    width: 4.66882,
    height: 0.804969,
    rx: 0.402485,
    transform: "rotate(-45 7.05884 10.2788)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9308_7466",
    x1: 10.2175,
    y1: -0.430098,
    x2: 4.71221,
    y2: 8.88652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9B52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8227"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9308_7466",
    x1: 2.97199,
    y1: 5.04514,
    x2: 11.6756,
    y2: 15.8247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9308_7466",
    x1: 11.3966,
    y1: 10.4242,
    x2: 6.37024,
    y2: 11.3747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9308_7466",
    x1: 7.80204,
    y1: 10.3726,
    x2: 7.9455,
    y2: 11.4032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlexibleOperation);
export default __webpack_public_path__ + "static/media/flexibleOperation.fba4497c1cb4160c71f83e45f693a13f.svg";
export { ForwardRef as ReactComponent };